const chunkChannelsToGroups = <T>(channels: T[], size: number): T[][] => {
  if (size <= 0 || channels.length === 0) {
    return [];
  }

  const groups: T[][] = [];
  for (let i = 0; i < channels.length; i += size) {
    groups.push(channels.slice(i, i + size));
  }
  return groups;
};

export default chunkChannelsToGroups;
